export var SET_VOTE_ENTITY_ID = "SET_VOTE_ENTITY_ID";
export function setVoteEntityId(id) {
    return function (dispatch) {
        dispatch({
            type: SET_VOTE_ENTITY_ID,
            payload: id,
        });
    };
}
//# sourceMappingURL=setVoteEntityId.js.mapexport var SET_VOTE_ENTITY_ID = "SET_VOTE_ENTITY_ID";
export function setVoteEntityId(id) {
    return function (dispatch) {
        dispatch({
            type: SET_VOTE_ENTITY_ID,
            payload: id,
        });
    };
}
//# sourceMappingURL=setVoteEntityId.js.map